import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { register } from 'register-service-worker';
//import { Http } from '@angular/http';

import { AppModule } from './app.module';
import { ENV } from '@app/env';

if (ENV.production) {
    enableProdMode();
    
    if(!ENV.isDebugMode && window && localStorage.getItem('debug') === null) {
        window.console.log=function(){};
    }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then( () => {
    if ( ENV.production == true ) {
      register('service-worker.js',
      {
        ready(registration){
          console.log("Service worker is active.");
        },
        registered(registration){
          console.log("Service worker has been registered.");
        },
        cached(registration){
          console.log("Content has been cached for offline use.");
        },
        updatefound(registration){
          console.log("New content is downloading.");
        },
        updated (registration){
          console.log("New content is available. Please Refresh.");
          //var http: Http;
          //http.get('/release.json').map(res => res.json()).subscribe(data => {
            //console.log(data);
          if (confirm ("Neue Version ist verfügbar! Seite neu laden?")) {
            window.location.reload();
          }
          //});          
        },
        offline(){
          console.log("No internet connnection found. App is running in offline mode.");
        },
        error(error){
          console.error("Error during servie worker registration:", error);
        }
      })
    } else {
      console.log("DEV Mode ohne ServiceWorker");
    }
  });



// WEBPACK FOOTER //
// ./src/app/main.ts